import { ScrollBox, ScrollBoxOptions } from "@pixi/ui";
import { IDestroyOptions, ObservablePoint } from "pixi.js";
import { Event } from "event-system";
import { gsap } from "gsap";

export class UIScrollBox extends ScrollBox {
    public readonly onScroll: Event<number> = new Event<number>();
    private previoutEventScrollValue: number = 0;

    public get elementsHeight(): number {
        return this.list.height;
    }

    public constructor(options?: ScrollBoxOptions) {
        super(options);
        this.setupListPositionChangeHandler();
    }

    private setupListPositionChangeHandler(): void {
        const callback = this.list.transform.position.cb.bind(this.list.transform);
        this.list.transform.position = new ObservablePoint(() => {
            this.onListPositionChange();
            callback();
        }, this, this.list.x, this.list.y);
    }

    private onListPositionChange(): void {
        const scrollValue = this.options.type === "horizontal" ? this._trackpad.x : this._trackpad.y;
        if (this.previoutEventScrollValue === scrollValue) {
            return;
        }
        this.previoutEventScrollValue = scrollValue;
        this.onScroll.emit(-this.previoutEventScrollValue);
    }

    public async udateChildsPositions(): Promise<void> {
        const animationTimeLine = new gsap.core.Timeline();
        let totalHeight = this.items[0].height + this.options.elementsMargin;
        for (let index = 0; index < this.items.length; index++) {
            if (index == 0) {
                continue
            };
            const element = this.items[index];
            if (this.options.type === 'horizontal') {
                //logic if type of ScrollBox is horizontal
            }
            else {
                const nextPositionY = this.items[0].position.y + totalHeight;
                animationTimeLine.to(element.position, { y: nextPositionY, duration: 0.2 }, "<");
            }
            totalHeight += this.items[index].height + this.options.elementsMargin;
        }
        await animationTimeLine;
        animationTimeLine.kill();
        this.resize();
    }

    // vlad: will be removed if unused
    public stopScrolling(): void {
        this._trackpad.pointerUp();
    }

    public setWheelScrollable(flag:boolean):void{
        if (!flag) {
            document.removeEventListener('wheel', this.onMouseScrollBinding, true);
            return;
        }
        document.addEventListener('wheel', this.onMouseScrollBinding, true);
    }

    public setScrollable(flag: boolean): void {
        this.setInteractive(flag);
    }
    
    public override destroy(options?: IDestroyOptions | boolean): void {
        const children = this.list.removeChildren();
        for (const child of children) {
            child.destroy(options);
        }
        super.destroy();
    }
}